<template>
    <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary" style="width:100%">
          <!-- Search container -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-search"></i>
                    </div>
                    <input
                      v-on:keyup.enter="onSearchEmail(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('common.info')"
                      v-model="search.sentInfo"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <dateRangePicker
                      :dateFormat="'DD/MM/YYYY'"
                      :dateFormatEmit="'DD-MM-YYYY'"
                      @applyDatePicker="emitApplyDatePicker"
                      @clearDatePicker="emitClearDatePicker"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-group"></i>
                    </div>
                    <select
                      name=""
                      id=""
                      class="form-control"
                      @change="onEmitSelectProject"
                      v-model="selectedSmtpProject"
                    >
                      <option
                        v-for="(smtpProject, index) in smtpProjectType"
                        :key="smtpProject + index"
                        :value="smtpProject.value"
                        >{{ $t(smtpProject.text) }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 0px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                      type="checkbox"
                      class="check-input"
                      id="onlyFailed"
                      v-model="search.failedOnly"
                    />
                    <label class="form-check-label" for="onlyFailed">{{
                      $t("email_history_agent.onlyFailed")
                    }}</label>
                </div>
                <div style="margin-right: 15px; margin-left: 15px">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onSearchEmail(1)"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary extra-tools"
                    :style="{
                      visibility: search.failedOnly ? 'visible' : 'hidden'
                    }"
                    @click="exportHistoryToExcel(($event))"
                  >
                    <i class="glyphicon glyphicon-open"></i>
                    {{ $t("common.exportFileExcel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <lte-table
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridEmailDataList"
              :columns="gridColumns"
              search_filter="left-search"
              :useFilter="useFilter"
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :customColumns="customColumns"
            ></lte-table>
            <div class="box-footer clearfix" style="display:contents;">
              <paginator :item="paginatorItem" @onpaginate="onPagination" />
            </div>
          </div>
        </div>
      </row>
    </div>
     <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTETable from "@/components/LTETable.vue";
import Paginator from "@/components/Paginator.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import DateRangePicker from '@/components/LTEDateRangePickerCustom.vue'
import Enum from "../../../enum/enum";
import utils from '@/lib/utils'
import constants from "@/lib/constantsData";
import XLSX from "xlsx";

export default {
  name: "MailHistoryAgent",
  data() {
    return {
      paginatorItem: {
          commit_function: "GET_LIST_EMAIL_HISTORY_AGENT"
      },
      boxStyle: false,
      useFilter: false,
      SMTPServiceEnum: Enum.SMTPServiceEnum,
      selectedSmtpProject: Enum.SMTPServiceEnum.BQL_SMTP,
      selectedSmtpProjectId: null,
      smtpProject: {
        projectIdBQL: null,
        projectIdCSKH: null,
        isUsePrivateSmtpCSHK: false,
      },
      smtpProjectType: [
        {
          value: Enum.SMTPServiceEnum.BQL_SMTP,
          text: "customization_table.customSMTPService.management_SMTP"
        },
        {
          value: Enum.SMTPServiceEnum.CSKH_SMTP,
          text: "customization_table.customSMTPService.CSKH_SMTP"
        }
      ],
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "email_history_agent.date", isHidden: true },
        { text: "email_history_agent.subject", isHidden: true },
        // { text: "email_history_agent.content", isHidden: true },
        // { text: "email_history_agent.schedule", isHidden: true },
        { text: "email_history_agent.to", isHidden: true },
        { text: "email_history_agent.cc", isHidden: true },
        { text: "email_history_agent.bcc", isHidden: true },
        { text: "email_history_agent.from", isHidden: true },
        { text: "email_history_agent.status", isHidden: true },
      ],
      exportExcelData: {
        headerList: [
          "email_history_agent.date",
          "email_history_agent.subject",
          "email_history_agent.to",
          "email_history_agent.cc",
          "email_history_agent.bcc",
          "email_history_agent.from",
          "email_history_agent.status"
        ],
        dataList: [],
        wscols: []
      },
      customColumns: {
        "email_history_agent.content": "none",
      },
      search: {
        sentInfo: null,
        fromDate: null,
        toDate: null,
        failedOnly: false,
      },
      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;",
      gridEmailDataList: [],
      isLoading: false,
      selected: null,
    };
  },
  watch: {
    GET_LANG: function() {
      // this.onSearchEmail(1)
    },
    GET_SETTING_PROJECT_SMTP_DATA: function() {
      this.smtpProject.projectIdBQL = this.GET_SETTING_PROJECT_SMTP_DATA.smtp_bql_project_id;
      this.smtpProject.projectIdCSKH = this.GET_SETTING_PROJECT_SMTP_DATA.smtp_cskh_project_id;
      this.smtpProject.isUsePrivateSmtpCSHK = this.GET_SETTING_PROJECT_SMTP_DATA.is_smtp_cskh_private;
      this.selectedSmtpProjectId = this.smtpProject.projectIdBQL
      this.onSearchEmail(1)
    },
    GET_LIST_EMAIL_HISTORY_AGENT_DATA: function() {
      this.gridEmailDataList = [];
      this.GET_LIST_EMAIL_HISTORY_AGENT_DATA.forEach((email, i) => {
        let attach_files = email.attach_files;
        if (attach_files != null)
        {
          attach_files = attach_files.substring(attach_files.lastIndexOf('/') + 1, attach_files.length);
          attach_files = attach_files.replace("']", "")
        }

        let data = {
          id: email.id,
          attach_files: attach_files,
          "common.nonumber": i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size,
          "email_history_agent.date": utils.formatSqlDate(email.date_sent, null, constants.dateOptions.format_date_time),
          "email_history_agent.subject":  email.mail_subject,
          "email_history_agent.from": email.sender_mail,
          "email_history_agent.bcc": email.bcc_addr,
          "email_history_agent.cc": email.cc_addr,
          "email_history_agent.to": email.to_addr,
          "email_history_agent.status": email.err_message,
        };
        this.gridEmailDataList.push(data);
      });
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_LIST_EMAIL_HISTORY_AGENT_DATA",
      "GET_SETTING_PROJECT_SMTP_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    onPagination: function(data) {
        this.onSearchEmail(data.params.page)
    },
    emitApplyDatePicker: function(data) {
      this.search.fromDate = data.start_date
      this.search.toDate = data.end_date
    },
    emitClearDatePicker: function(data) {
      this.search.fromDate = data.start_date
      this.search.toDate = data.end_date
    },
    onSearchEmail(page) {
      const data = {
        params: {
          smtpProjectId: this.selectedSmtpProjectId,
          page: page,
          fromDate: this.search.fromDate,
          toDate: this.search.toDate,
          searchData: this.search.sentInfo,
          failedOnly: this.search.failedOnly,
        }
      }
      this.isLoading = true
      this.GET_LIST_EMAIL_HISTORY_AGENT(data).then(
        function(){
          this.isLoading = false
        }.bind(this)
      ).catch(
        function(){
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: this.$t("customization_table.err_missing_info"),
            styleType: "danger"
          });
        }.bind(this)
      )
    },
    // export excel
    exportHistoryToExcel: function() {
      const data = {
        params: {
          smtpProjectId: this.selectedSmtpProjectId,
          fromDate: this.search.fromDate,
          toDate: this.search.toDate,
          searchData: this.search.sentInfo,
          failedOnly: this.search.failedOnly
        }
      }
      this.isLoading = true
      this.GET_EXPORT_EMAIL_HISTORY(data).then(
        async function(res){
          this.isLoading = false
          // let data = res.data
          let dataList = this.getDataExcelJson(
            this.exportExcelData.headerList,
            res
          );
          await this.createExcelFile(dataList);
        }.bind(this)
      ).catch(
        function(){
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: this.$t("customization_table.err_missing_info"),
            styleType: "danger"
          });
        }.bind(this)
      )
    },
    createExcelFile: function(jsonData) {
      let data_list = [];
      data_list = jsonData;
      var excelFileData = XLSX.utils.json_to_sheet(data_list);

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, excelFileData, "delivery_failed_log");
      excelFileData['!cols'] = this.exportExcelData.wscols
      XLSX.writeFile(wb, "EmailDeliveryLog.xlsx");
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];

      let email_date = headerList[0];
      let email_subject = headerList[1];
      let email_to = headerList[2];
      let email_cc = headerList[3];
      let email_bcc = headerList[4];
      let email_from = headerList[5];
      let email_status = headerList[6];

      dataList.forEach(email => {
        let item = {
          [this.$t(email_date)]: utils.formatSqlDate(email.date_sent, null, constants.dateOptions.format_date_time),
          [this.$t(email_subject)]: email.mail_subject,
          [this.$t(email_to)]: email.to_addr,
          [this.$t(email_cc)]: email.cc_addr,
          [this.$t(email_bcc)]: email.bcc_addr,
          [this.$t(email_from)]: email.sender_mail,
          [this.$t(email_status)]: email.err_message,
        }
        resultList.push(item)
        this.getWscols(item)
      });
      return resultList;
    },
    getWscols: function(obj) {
      let wscolsLength = this.exportExcelData.wscols.length
      let cellWidthDefault = 10
      if (wscolsLength === 0) {
        let objKeys = Object.keys(obj)
        objKeys.forEach(k=> {
          let cellWidth = utils.isEmptyString(obj[k])
            ? cellWidthDefault
            : obj[k].toString().length > cellWidthDefault ? obj[k].toString().length : cellWidthDefault
          this.exportExcelData.wscols.push(
            {wch: cellWidth})
        })
      } else {
        let objKeys = Object.keys(obj)
        objKeys.forEach((k, i)=> {
          if (!utils.isEmptyString(obj[k]) && obj[k].toString().length > this.exportExcelData.wscols[i].wch) {
            this.exportExcelData.wscols[i].wch = obj[k].toString().length
          }
        })
      }
    },
    onEmitSelectProject() {
      let newSelectedId = this.selectedSmtpProjectId
      if (this.selectedSmtpProject == this.SMTPServiceEnum.BQL_SMTP) {
        newSelectedId = this.smtpProject.projectIdBQL
      } else if (this.selectedSmtpProject == this.SMTPServiceEnum.CSKH_SMTP) {
        newSelectedId = this.smtpProject.projectIdCSKH
      }
      if (newSelectedId != this.selectedSmtpProjectId) {
        this.selectedSmtpProjectId = newSelectedId
        this.onSearchEmail(1)
      }
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_LIST_EMAIL_HISTORY_AGENT",
      "GET_EXPORT_EMAIL_HISTORY",
      "GET_SETTING_PROJECT_SMTP"
    ]),
  },
  mounted() {
    this.GET_SETTING_PROJECT_SMTP();
  },
  components: {
    loading: Loading,
    "lte-table": LTETable,
    "paginator": Paginator,
    "lte-core-alert": LTECoreAlert,
    DateRangePicker
  }
};
</script>

<style>
.page-item.disabled .page-link{
    display: none;
}
.detail-email {
  display: flex;
  flex-direction: row;
}
.row-email.button {
  text-align: center;
  border-top: 2px solid;
}
.left-email-content {
    width: 10%;
}
.right-email-content {
    width: 90%;
}
.row-email, .content-email {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementMailHistoryAgent.vue